import React, { useEffect, useState, useRef } from 'react'

import Validator from '@/pages/form/validator/Validator'
import { requiredCheckedValidator } from '@/utils/validators'
import Label from '@components/labels/Label'

import './CheckAndLabel.css'

interface CheckAndLabelProps {
	id: string
	name: string
	text: string
	onChange: (value: boolean) => void
	checked?: boolean
	// Whether the box has to be ticked. It does unless told otherwise.
	required?: boolean
}

function CheckAndLabel(props: CheckAndLabelProps) {
	const ref = useRef<any>({ value: false })
	const [errors, setErrors] = useState<string[]>([])

	useEffect(() => {
		ref.current.value = props.checked ?? false
	}, [props.checked])

	const validator = (input: string) =>
		props.required === false
			? []
			: [requiredCheckedValidator(input, "Veuillez accepter les conditions d'utilisation.")]

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		props.onChange(e.currentTarget.checked)
		ref.current.value = e.currentTarget.checked
	}

	const handleError = (errors: string[]) => {
		setErrors(errors)
	}

	return (
		<Validator id={props.id} validator={validator} reference={ref} onError={handleError}>
			<div className='CheckAndLabel'>
				<div className='flex'>
					<input
						type='checkbox'
						id={props.id}
						name={props.name}
						value={props.id}
						checked={props.checked ?? false}
						onChange={handleChange}
					/>
					<Label htmlFor={props.id}>{props.text}</Label>
				</div>
				{errors.map((error, index) =>
					error !== '' ? (
						<span key={index} className='error'>
							{error}
						</span>
					) : null,
				)}
			</div>
		</Validator>
	)
}

export default CheckAndLabel
